import { GlobalConstants } from "../data/GlobalConstants";
import { handleResponse } from "../util/functions";
import { getToken } from "../helpers/helperJWT";
import { loaderService } from "./loaderService";

const url = GlobalConstants.urlApi;

export const preciosService = {
    getSelects,
    getProductsByPorfatolio,
    crudPrecios,
    getFilteredData,
    getPreciosById,
    validarCargueExcel,
    guardarCargueExcel,
    setIntegridad
};

function getSelects(codigo) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({ codigo })
    };

    return fetch(`${url}/precios/getSelects`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProductsByPorfatolio(data) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({ data })
    };

    return fetch(`${url}/precios/getProductsByPorfatolio`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudPrecios(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/precios/crudPrecios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFilteredData(data, show) {
    if(show){
        loaderService.showLoader({ label: "Cargando..." });
    }
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/precios/getFilteredData`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getPreciosById(id) {
    loaderService.showLoader({ label: "Cargando..." });
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({id})
    };

    return fetch(`${url}/precios/getPreciosById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function validarCargueExcel(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/precios/validarExcel`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function guardarCargueExcel(data) {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/precios/setPreciosExcel`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setIntegridad(idUsuario){
    loaderService.showLoader({ labe: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({idUsuario})
    };

    return fetch(`${url}/precios/setIntegridad`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}
